import React from 'react';
import _ from 'lodash';
import { Select as AntdSelect } from 'antd';
import Loader from '../loader/Loader';

function Select({
  id,
  name,
  value,
  placeholderText,
  onChange,
  optGroups,
  options,
  label,
  loading,
  required,
  className,
  disabled,
  error,
  multiple,
  allowClear
}) {
  return (
    <div className={`${className} inputBox text-sm tracking-tight space-y-1`}>
      {loading && (<div className="px-2 mt-5 ml-2"><Loader /></div>)}
      {!loading && !multiple && (
        <select
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          disabled={disabled || loading}
          placeholder={placeholderText}
          className={`inputField disabled:bg-gray-100 disabled:text-gray-400 placeholder-gray-400 text-gray-900 text-base rounded-md p-3 w-full appearance-none focus:ring-1 focus:ring-accent border ${error ? 'border-red-500' : 'border-gray-200'} focus:border-accent outline-none focus:outline-none transition ease-in-out duration-500`}
        >
          {_.map(options, (option) => (
            <option
              key={option.key}
              value={option.value}
              disabled={option.disabled}
            >
              {option.text}
            </option>
          ))}
          {_.map(optGroups, (group) => (
            <optgroup label={group.name}>
              {_.map(group.options, (option) => (
                <option
                  key={option.key}
                  value={option.value}
                  disabled={option.disabled}
                >
                  {option.text}
                </option>
              ))}
            </optgroup>
          ))}
        </select>
      )}
      {!loading && multiple && (
        <AntdSelect
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          disabled={disabled || loading}
          allowClear={allowClear ?? false}
          mode="multiple"
          placeholder={placeholderText}
          className={`inputField bg-transparent disabled:bg-gray-100 disabled:text-gray-400 placeholder-gray-400 text-gray-900 text-base rounded-md w-full appearance-none focus:ring-1 focus:ring-accent border ${error ? 'border-red-500' : 'border-gray-200'} focus:border-accent outline-none focus:outline-none transition ease-in-out duration-500`}
        >
          {_.map(options, (option) => (
            <AntdSelect.Option
              key={option.key}
              value={option.value}
              disabled={option.disabled}
            >
              {option.text}
            </AntdSelect.Option>
          ))}
        </AntdSelect>
      )}
      <span className="inputLabel text-sm inputLabel-raised">{label}{required && <span className="text-red-500 ml-1">*</span>}</span>
      {error && <div className="text-sm ml-2 font-light text-red-500">{error}</div>}
    </div>
  );
}

export default Select;
